import { update } from 'api/needsassessments';
import { updateExternalNA, updateActivityLog } from 'api/externalAccess';
import actions from 'store/actions';
import { save, remove } from 'api/sharedneedsassessments';
import { defineType } from 'utils/externalAccess';
import searchParams from 'constants/searchParams';

export const updateNA = async (_, getState) => {
  const na = getState().na;
  await update(na);
};

export const updateExternalAccessNA = ({ hasChanged }) => async (_, getState) => {
  const params = new URLSearchParams(window.location.search);
  const preview = params.get(searchParams.preview);
  const na = getState().na;
  const accessKey = getState().externalAccessConfig.accessKey;
  const response = await updateExternalNA(na, accessKey);
  if (preview !== 'true' && hasChanged) {
    await updateActivityLog({
      accessKey: accessKey,
      na: response,
      type: defineType(getState().externalAccessConfig.brokerNaId, response.id),
      updateLastUpdate: true
    });
  }
};

export const addSharedTeamMember = (teamMember) => async (dispatch, getState) => {
  const na = getState().na;

  if (na.sharedUsers.some((sharedUser) => sharedUser.id === teamMember.id)) return;

  await save(na.id, teamMember.id);
  dispatch(actions.na.addSharedUser(teamMember));
};

export const removeSharedTeamMember = (teamMember) => async (dispatch, getState) => {
  const na = getState().na;

  if (!na.sharedUsers.some((sharedUser) => sharedUser.id === teamMember.id)) return;

  await remove(na.id, teamMember.id);
  dispatch(actions.na.removeSharedUser(teamMember));
};
